<template>
  <div>
    <div class="row">
      <div
        v-if="filtro.type === 'ENUM'"
        v-for="(filtro, index) in filtri"
        :key="index"
        :class="columnclass"
      >
        <vue-select
          :name="filtro.name"
          :multiple="filtro.multiple"
          :closeonselect="!filtro.multiple"
          :options="filtro.options"
          :labelcolor="labelcolor"
          :primarycolor="primarycolor"
          :allowEmpty="true"
          :title="filtro.label"
          trackby="id"
          label="label"
          :selectname="filtro.name"
          :currentvalue="hasValueSelect(filtro, currentvalue)"
          @onChange="$emit('setfiltroavanzato', { name: filtro.name, value: $event, type: 'select', multiple: filtro.multiple })"
        >
        </vue-select>
      </div>
    </div>
    <div class="row">
      <div
        v-for="(filtro, index) in filtri"
        :key="index"
        :class="columnclass"
        v-if="filtro.type === 'CHECKBOX'"
      >
        <div class="checkbox checkbox-theme checkbox-circle">
          <input
            type="checkbox"
            :id="id_text_prepend + filtro.name"
            :name="filtro.name"
            :checked="hasValueCheckbox(filtro, currentvalue)"
            @change="$emit('setfiltroavanzato', { name: filtro.name, value: $event, type: 'checkbox', multiple: false })"
          >
          <label
            class="form-check-label"
            :for="id_text_prepend + filtro.name"
          >
            {{ filtro.label }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "advanced-filters",
  props: ['filtri', 'labelcolor', 'primarycolor', 'columnclass', 'currentvalue', 'id_text_prepend'],
  methods: {
    hasValueSelect: (filtro, currentValue) => {
      let valueToUse = _.filter(currentValue, (fValue, key) => {
        return key === filtro.name
      })

      // nel caso abbia un array di array
      valueToUse = _.flatten(valueToUse)

      if (filtro.multiple) {
        return _.filter(filtro.options, (pOption) => {
          return _.indexOf(valueToUse, parseInt(pOption.id)) !== -1
        })
      } else {
        let myArray =
          _.filter(
            filtro.options,
            (pOption) => {
              return _.indexOf(valueToUse, parseInt(pOption.id)) !== -1
            })
        return myArray[0] ? myArray[0].id : null
      }
    },
    hasValueCheckbox (filtro, currentValue) {
      return (currentValue && currentValue[filtro.name]) ? currentValue[filtro.name] : false
    }
  }
}
</script>
